import React from "react";
import './s6.scss'
import {EMAIL, WHATS_APP} from "../../../utils";

const S6 = () => {
  return (
    <div className="gogo-s-6">
      <div className="s-6-inner">
        <div className="logo-wrapper">
          <div className="logo"></div>
          <p className="logo-text">GOGO Credi</p>
        </div>
        <div className="contact">
          {
            WHATS_APP &&
            <p className="wa">Whatsapp: {WHATS_APP}</p>
          }
          <p>Correo electrónico: {EMAIL}</p>
        </div>
      </div>
      <div className="dollar-12 absolute"></div>
      <div className="spark-7 absolute"></div>
      <div className="spark-8 absolute"></div>
    </div>
  )
}

export default S6;
